export const genderEnum = {
    'male': 1,
    'female': 2
}